/**
 * @author Madhu.Sudhan
 * @Date: 2023-04-29 13:05:06
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-04-29 17:50:20
 */

import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Card, Row, Col, Form, Breadcrumb, Slider, Divider, Button, Switch } from 'antd';
import { AppWrappperHOC } from '../Root/HOC';
import { CALCULATE_BALANCE } from './constants';
import { constants, utils } from '../../devUtils';
import Container from '../../components/Container';
import { ZaggleCard, NsdlFlipCards } from '../NetworkCards/StyledNetworkCard';
import { StyledNsdlTransactionLimits } from './StyledNsdlTransactionLimits';
import { NsdlTransactionLimitsMapDispatchToProps, NsdlTransactionLimitsPropTypes, NsdlTransactionLimitsMapStateToProps } from './NsdlTransactionLimitsDatahandler';

class NsdlTransactionLimits extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      atm: '',
      pos: '',
      ecom: '',
      nfc: '',
      ecom_virtual: '',
      atm_enabled: true,
      pos_enabled: true,
      ecom_enabled: true,
      nfc_enabled: true,
      ecom_virtual_enabled: false,
    };
    this.statelesskeys = {
      defaultPayload: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleVirtualSubmit = this.handleVirtualSubmit.bind(this);
  }

  componentDidMount() {
    const {
      match: { params: { id } },
      onFetchCardData,
      onFetchNsdlM2pTransactionLimits,
    } = this.props;
    onFetchCardData(id);
    onFetchNsdlM2pTransactionLimits();
  }

  componentWillReceiveProps(nextProps) {
    const {
      fetchNsdlM2pLimits,
      fetchNsdlM2pLimits: {
        status,
        limits,
      } = {},
      updateNsdlM2pLimits,
      updateNsdlM2pLimits: { status: limits_status } = {},
      onFetchNsdlM2pTransactionLimits,
    } = nextProps;
    const {
      fetchNsdlM2pLimits: _fetchNsdlM2pLimits,
      updateNsdlM2pLimits: _updateNsdlM2pLimits,
    } = this.props;
    if (!utils.isEqual(fetchNsdlM2pLimits, _fetchNsdlM2pLimits) && status && limits && limits.length === 4) {
      this.setState({
        atm: limits[0].daily_txn || '',
        pos: limits[1].daily_txn || '',
        ecom: limits[2].daily_txn || '',
        nfc: limits[3].daily_txn || '',
        atm_enabled: limits[0].is_enabled || false,
        pos_enabled: limits[1].is_enabled || false,
        ecom_enabled: limits[2].is_enabled || false,
        nfc_enabled: limits[3].is_enabled || false,
      });
    } else if (!utils.isEqual(fetchNsdlM2pLimits, _fetchNsdlM2pLimits) && status && limits) {
      this.setState({
        ecom_virtual: limits[0].daily_txn || '',
        ecom_virtual_enabled: limits[0].is_enabled,
      });
    } else if (!utils.isEqual(updateNsdlM2pLimits, _updateNsdlM2pLimits) && limits_status) {
      onFetchNsdlM2pTransactionLimits();
    }
  }

  handleSubmit() {
    const { atm, pos, ecom, nfc, atm_enabled, pos_enabled, ecom_enabled, nfc_enabled } = this.state;
    const { fetchNsdlM2pLimits: {
      limits = [],
    } = {},
    onUpdateNsdlM2pTransactionLimits,
    } = this.props;
    const setLimit = [];
    limits.forEach(({ channel, channel_name, daily_cnt, min, max, icon }, index) => {
      let is_enabled;
      let daily_txn;

      switch (index) {
        case 0:
          is_enabled = atm_enabled;
          daily_txn = atm;
          break;
        case 1:
          is_enabled = pos_enabled;
          daily_txn = pos;
          break;
        case 2:
          is_enabled = ecom_enabled;
          daily_txn = ecom;
          break;
        case 3:
          is_enabled = nfc_enabled;
          daily_txn = nfc;
          break;
        default:
          is_enabled = false;
          daily_txn = 0;
      }

      const ob = {
        channel,
        channel_name,
        is_enabled,
        daily_txn,
        daily_cnt,
        min,
        max,
        icon,
      };
      setLimit.push(ob);
    });
    onUpdateNsdlM2pTransactionLimits({ limits: setLimit });
  }

  handleVirtualSubmit() {
    const { ecom_virtual, ecom_virtual_enabled } = this.state;
    const { fetchNsdlM2pLimits: {
      limits = [],
    } = {},
    onUpdateNsdlM2pTransactionLimits,
    } = this.props;
    const setLimit = [];
    const virtualLimit = limits && limits.length ? limits[0] : {};
    const payload = {
      channel: virtualLimit.channel || '',
      channel_name: virtualLimit.channel_name || '',
      is_enabled: ecom_virtual_enabled || false,
      daily_txn: ecom_virtual || '',
      daily_cnt: virtualLimit.daily_cnt || '',
      min: virtualLimit.min || '',
      max: virtualLimit.max || '',
      icon: virtualLimit.icon || '',
    };
    setLimit.push(payload);
    onUpdateNsdlM2pTransactionLimits({ limits: setLimit });
  }

  handleSwitch(type, value) {
    switch (type) {
      case 'ATM Transactions':
        this.setState({ atm_enabled: value });
        break;
      case 'POS Transactions':
        this.setState({ pos_enabled: value });
        break;
      case 'ECOM Transactions':
        this.setState({ ecom_enabled: value });
        break;
      case 'Virtual ECOM Transactions':
        this.setState({ ecom_virtual_enabled: value });
        break;
      case 'Contactless Transactions':
        this.setState({ nfc_enabled: value });
        break;
      default:
        break;
    }
  }

  handleChange(type, value) {
    switch (type) {
      case 'ATM Transactions':
        this.setState({ atm: value });
        break;
      case 'POS Transactions':
        this.setState({ pos: value });
        break;
      case 'ECOM Transactions':
        this.setState({ ecom: value });
        break;
      case 'Virtual ECOM Transactions':
        this.setState({ ecom_virtual: value });
        break;
      case 'Contactless Transactions':
        this.setState({ nfc: value });
        break;
      default:
        break;
    }
  }

  renderCvvPresentImage(cardData) {
    let showImage = null;
    const { cvv, card_type, card_name, expiry_month, expiry_year, CardStatus } = cardData;
    showImage = (
      <Fragment>
        <input type="checkbox" id="CardClick" />
        <label className="card-containert" htmlFor="CardClick">
          <div className="card-flip">
            <div className="side default-user" >
              <h1><strong>Rs. {CALCULATE_BALANCE(cardData, card_type)}</strong></h1>
              <h2>{card_name}</h2>
              <div className="footer">
                <b>
                  <span>Card Number:</span> {cardData.ProxyNumber}<br />
                  <span>Expiry:</span> {expiry_month}/{expiry_year}<br />
                  <span>Card Status:</span> {CardStatus}<br />
                  <span>{CardStatus === 'Locked'}</span>
                </b>
              </div>
            </div>
            <div className="side back">
              <h3>{cvv}</h3>
            </div>
          </div>
        </label>
      </Fragment>
    );
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        <NsdlFlipCards>
          {showImage}
        </NsdlFlipCards>
      </Col>
    );
  }

  renderCvvBlankImage(cardData) {
    let showImage = null;
    const { card_type, card_name, expiry_month, expiry_year, CardStatus } = cardData;
    showImage = (
      <div className="card-flip default">
        <div className="side default-user" >
          <h1><strong>Rs. {CALCULATE_BALANCE(cardData, card_type)}</strong></h1>
          <h2>{card_name}</h2>
          <div className="footer">
            <Row align="middle" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <b>
                  <span>Card Number:</span> {cardData.ProxyNumber}<br />
                  {expiry_month ? <Fragment><span>Expiry:</span> {expiry_month}/{expiry_year}<br /></Fragment> : null}
                  <span>Card Status:</span> {CardStatus}<br />
                  <span>{CardStatus === 'Locked'}</span>
                </b>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        <NsdlFlipCards>
          {showImage}
        </NsdlFlipCards>
      </Col>
    );
  }

  renderCardImages(cardData) {
    const { cvv } = cardData;
    return cvv ? this.renderCvvPresentImage(cardData) : this.renderCvvBlankImage(cardData);
  }

  renderSetLimits(name, limitValue, enabled, index) {
    const { fetchNsdlM2pLimits: {
      limits = [],
    } = {},
    } = this.props;
    return (
      <Fragment>
        {limits && limits.length ?
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-b-1">
            <h3 className="nomargin">{name}</h3>
            <Row align="middle" type="flex" gutter={[15, 15]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                  <div className="font-12">Current Limit</div>
                  <div className="font-12">{limits[index].daily_txn || 0}</div>
                </Col>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                  <div className="font-12">New Limit</div>
                  <div className="font-12">{limitValue}</div>
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Switch
                    className="custom-switch"
                    checked={enabled}
                    onChange={(value) => this.handleSwitch(name, value)}
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <span className="font-12">{name}</span>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Slider
                    min={0}
                    max={limits[index].max || 0}
                    step={100}
                    className="custom-slider"
                    value={Number(limitValue) || 0}
                    onChange={(value) => this.handleChange(name, value)}
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div className="show-slider-values">
                    <span>0</span>
                    <span>{limits[index].max || 0}</span>
                  </div>
                </Col>
              </Col>
            </Row>
            <Divider className="margin-t-1 margin-b-1" />
          </Col> : '' }
      </Fragment>
    );
  }

  renderVirtualSetLimits(name, limitValue, enabled) {
    const { fetchNsdlM2pLimits: {
      limits = [],
    } = {},
    isTransactionLimitsLoading,
    } = this.props;
    return (
      <Fragment>
        {limits && limits.length ?
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-b-1">
            <h3 className="nomargin">ECOM Transactions</h3>
            <Row align="middle" type="flex" gutter={[15, 15]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                  <div className="font-12">Current Limit</div>
                  <div className="font-12">{limits[0].daily_txn || 0}</div>
                </Col>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                  <div className="font-12">New Limit</div>
                  <div className="font-12">{limitValue}</div>
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Switch
                    className="custom-switch"
                    checked={enabled}
                    onChange={(value) => this.handleSwitch(name, value)}
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <span className="font-12">{name}</span>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Slider
                    min={0}
                    max={limits[0].max || 0}
                    step={100}
                    className="custom-slider"
                    value={Number(limitValue) || 0}
                    onChange={(value) => this.handleChange(name, value)}
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div className="show-slider-values">
                    <span>0</span>
                    <span>{limits[0].max || 0}</span>
                  </div>
                </Col>
              </Col>
            </Row>
            <Divider className="margin-t-1 margin-b-1" />
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
              <Button
                loading={isTransactionLimitsLoading}
                className="ant-btn green-btn width-8"
                onClick={() => this.handleVirtualSubmit()}
              >Update Limits
              </Button>
            </Col>
          </Col> : '' }
      </Fragment>
    );
  }

  renderNsdlTransactionLimits() {
    const { fetchNsdlM2pLimits: {
      limits = [],
    } = {},
    match:
    {
      params:
      {
        id = '',
      } = {},
    },
    isTransactionLimitsLoading,
    } = this.props;
    const { atm, pos, ecom, nfc, ecom_virtual, atm_enabled, pos_enabled, ecom_enabled, nfc_enabled, ecom_virtual_enabled } = this.state;
    return (
      <Fragment>
        { limits && limits.length ?
          <Col xs={24} sm={24} md={14} lg={14} xl={14}>
            <StyledNsdlTransactionLimits>
              { id !== 'Virtual' ?
                <Fragment>
                  {this.renderSetLimits('ATM Transactions', atm, atm_enabled, 0)}
                  {this.renderSetLimits('POS Transactions', pos, pos_enabled, 1)}
                  {this.renderSetLimits('ECOM Transactions', ecom, ecom_enabled, 2)}
                  {this.renderSetLimits('Contactless Transactions', nfc, nfc_enabled, 3)}
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                    <Button
                      loading={isTransactionLimitsLoading}
                      className="ant-btn green-btn width-8"
                      onClick={() => this.handleSubmit()}
                    >Update Limits
                    </Button>
                  </Col>
                </Fragment>
                : ''}
              {id === 'Virtual' && this.renderVirtualSetLimits('Virtual ECOM Transactions', ecom_virtual, ecom_virtual_enabled)}
            </StyledNsdlTransactionLimits>
          </Col>
          : '' }
      </Fragment>
    );
  }

  render() {
    const {
      cardData = {},
    } = this.props;
    return (
      <Fragment>
        <Container>
          <ZaggleCard>
            <Row align="middle" type="flex" gutter={24} className="margin-t-2">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h1>Manage Zaggle Cards</h1>
                <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                  <Breadcrumb.Item href={constants.LINK_MY_PROFILE} className="crumb-link">My Account</Breadcrumb.Item>
                  <Breadcrumb.Item href={constants.LINK_PAY_BALANCE} className="crumb-link">Manage Cards</Breadcrumb.Item>
                  <Breadcrumb.Item>Manage Card Usage</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded noborder noshadow">
              <Row align="top" type="flex" gutter={30}>
                {this.renderCardImages(cardData)}
                {this.renderNsdlTransactionLimits()}
              </Row>
            </Card>
          </ZaggleCard>
        </Container>
      </Fragment>
    );
  }
}

NsdlTransactionLimits.propTypes = NsdlTransactionLimitsPropTypes;

const NsdlTransactionLimitsWrapper = Form.create({ name: 'normal_admin' })(NsdlTransactionLimits);
const component = connect(NsdlTransactionLimitsMapStateToProps, NsdlTransactionLimitsMapDispatchToProps)(AppWrappperHOC(NsdlTransactionLimitsWrapper));
export { NsdlTransactionLimits, NsdlTransactionLimitsWrapper };
export default component;



// WEBPACK FOOTER //
// client/containers/NsdlTransactionLimits/index.js